import { render, staticRenderFns } from "./FormChangeStatus.vue?vue&type=template&id=1bc3d410&"
import script from "./FormChangeStatus.vue?vue&type=script&lang=js&"
export * from "./FormChangeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports